// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"08feb230","977":"542522ab"}[chunkId] + ".chunk.js";
};